var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      Object.keys(_vm.listConfiguration).length &&
      Object.keys(_vm.serverSideData).length > 0 &&
      !_vm.showSpinnerLayer
        ? _c("GridTableComponent", {
            ref: "grid",
            attrs: {
              itemsData: _vm.serverSideData,
              itemsDataExport: _vm.serverSideDataExport,
              gridConfiguration: _vm.gridConfiguration,
              title: _vm.$t("views.actions.title"),
              toolbarOptions: _vm.toolbarOptionsCustom,
              contextMenuItems: _vm.contextMenu,
              listName: _vm.listConfiguration["Alias"],
              useServerPagination: _vm.useServerPagination,
              recordClick: _vm.onCellClicked,
              context: _vm.actionContext,
              archivedFilter: _vm.archivedSelectedOption,
              customToolbarContextMenuItems: _vm.actionsContextMenu,
              commandClick: _vm.commandClick,
              usePersistSelection: true,
            },
            on: {
              selectedRecords: _vm.onSelectedRecords,
              cellClicked: _vm.onCellClicked,
              contextMenuBeforeOpen: _vm.onCustomContextMenuBeforeOpen,
              contextMenuClicked: _vm.onContextMenuClicked,
              gridActionChange: _vm.gridActionChange,
              gridExportData: _vm.gridExportData,
              toolbarClicked: _vm.onToolbarClicked,
              customToolbarContextMenuClick: _vm.onActionAddClick,
            },
          })
        : _vm._e(),
      _c("ejs-contextmenu", {
        staticClass: "context-menu-component e-contextmenu-archived",
        attrs: {
          id: _vm.idActionsArchivedContextMenu,
          items: _vm.actionsArchivedContextMenuItems,
          select: _vm.onActionsArchivedClick,
        },
      }),
      _vm.changeStatusDialog
        ? _c("ChangeStatusDialogComponent", {
            attrs: {
              showDialog: _vm.changeStatusDialog,
              selection: _vm.gridSelection,
            },
            on: { close: _vm.onStatusDialogClose },
          })
        : _vm._e(),
      _vm.billableDialog
        ? _c("BillableDialogComponent", {
            attrs: {
              showDialog: _vm.billableDialog,
              selection: _vm.gridSelection,
            },
            on: { close: _vm.onBillableDialogClose },
          })
        : _vm._e(),
      _vm.noBillableDialog
        ? _c("NoBillableDialogComponent", {
            attrs: {
              showDialog: _vm.noBillableDialog,
              selection: _vm.gridSelection,
            },
            on: { close: _vm.onNoBillableDialogClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }